// hooks/use-engagement-tracker.ts
import { useCallback, useEffect, useRef } from "react";

interface UseEngagementTrackerOptions {
  sessionKey: string;
  timeoutMs?: number;
  onEngagement: () => void;
}

export const useEngagementTracker = ({ sessionKey, timeoutMs = 10000, onEngagement }: UseEngagementTrackerOptions) => {
  const hasTrackedRef = useRef(false);

  const track = useCallback(() => {
    if (hasTrackedRef.current || sessionStorage.getItem(sessionKey)) {
      return;
    }

    hasTrackedRef.current = true;
    sessionStorage.setItem(sessionKey, "true");
    onEngagement();
  }, [sessionKey, onEngagement]);

  // Auto-track after timeout
  useEffect(() => {
    const timer = setTimeout(track, timeoutMs);
    return () => clearTimeout(timer);
  }, [track, timeoutMs]);

  // Return manual track function for click events
  return { track };
};
